import { render } from "./MovableView.vue?vue&type=template&id=2530f955&scoped=true"
import script from "./MovableView.vue?vue&type=script&lang=js"
export * from "./MovableView.vue?vue&type=script&lang=js"

import "./MovableView.vue?vue&type=style&index=0&id=2530f955&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2530f955"]])

export default __exports__